import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { FeatureFlagsStoreModule } from './module';

export const FeatureFlagsModule = getModule(FeatureFlagsStoreModule, store);
